
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class MaterialInItemsGrid extends Serenity.EntityGrid<MaterialInItemsRow, any> {
        protected getColumnsKey() { return 'Purchase.MaterialInItems'; }
        protected getDialogType() { return MaterialInItemsDialog; }
        protected getIdProperty() { return MaterialInItemsRow.idProperty; }
        protected getInsertPermission() { return MaterialInItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialInItemsRow.localTextPrefix; }
        protected getService() { return MaterialInItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }

        protected getSlickOptions() {
            let opt = super.getSlickOptions();
            opt.editable = true;
            opt.autoEdit = true;
            //opt.forceFitColumns = true;
            return opt;
        }
        
    }
}